import React, { HtmlHTMLAttributes } from "react";
import { VariantProps } from "class-variance-authority";

import { tagVariants } from "./variants";
import { cn } from "@/libs/cn";

export interface TagProps extends HtmlHTMLAttributes<HTMLDivElement>, VariantProps<typeof tagVariants> {
  label: string | React.ReactNode;
}

const Tag = React.forwardRef<HTMLDivElement, TagProps>(({ font, variant, border, width, size, label, className, ...props }, ref) => {
  return (
    <div ref={ref} className={cn(tagVariants({ font, variant, border, width, size, className }))} {...props}>
      {label}
    </div>
  );
});

Tag.displayName = "Tag";

export default Tag;
